export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'origin',
    name: '品种起源',
    description: '探索大鸡巴品种的历史渊源、地理分布与育种历程，了解这一特色家禽的来龙去脉。',
    icon: 'ri-history-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20countryside%20farm%20with%20free%20range%20chickens%20roaming%20in%20a%20sunlit%20orchard%2C%20warm%20golden%20hour%20light%2C%20rustic%20wooden%20coop%20in%20distance%2C%20lush%20green%20hills%2C%20natural%20and%20peaceful%20agricultural%20scene%2C%20soft%20earthy%20tones%2C%20editorial%20photography%20style%20with%20gentle%20depth%20of%20field&width=600&height=300&seq=cat-origin&orientation=landscape',
  },
  {
    slug: 'appearance',
    name: '外形特征',
    description: '详细介绍大鸡巴的体型结构、羽毛颜色、冠型特点等外表识别特征，帮助精准辨识品种。',
    icon: 'ri-eye-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20portrait%20of%20a%20majestic%20large%20rooster%20with%20vibrant%20reddish%20brown%20feathers%20and%20prominent%20comb%2C%20standing%20proudly%20in%20a%20sunlit%20farmyard%2C%20warm%20natural%20lighting%2C%20sharp%20detail%20on%20plumage%20texture%2C%20soft%20earthy%20background%2C%20professional%20wildlife%20photography%20style&width=600&height=300&seq=cat-appearance&orientation=landscape',
  },
  {
    slug: 'breeding',
    name: '养殖技术',
    description: '系统讲解大鸡巴的繁殖孵化、育雏管理、成鸡饲养等核心养殖技术，助力科学养殖。',
    icon: 'ri-seedling-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20organized%20poultry%20farm%20interior%20with%20clean%20rowing%20of%20feeding%20stations%2C%20healthy%20chickens%20in%20well%20ventilated%20coop%2C%20natural%20light%20streaming%20through%20windows%2C%20professional%20agricultural%20setting%2C%20warm%20wood%20tones%20with%20white%20walls%2C%20clean%20and%20hygienic%20environment&width=600&height=300&seq=cat-breeding&orientation=landscape',
  },
  {
    slug: 'feeding',
    name: '饲养管理',
    description: '涵盖大鸡巴的饲料配比、日常管理、疫病防控等实用知识，提升养殖管理水平。',
    icon: 'ri-bowl-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Healthy%20organic%20chicken%20feed%20mix%20with%20corn%20grains%20and%20soybeans%20in%20a%20rustic%20wooden%20bowl%2C%20placed%20on%20a%20farm%20table%20with%20soft%20morning%20sunlight%2C%20surrounded%20by%20fresh%20greens%2C%20natural%20earthy%20aesthetic%2C%20warm%20and%20inviting%20agricultural%20still%20life%20photography&width=600&height=300&seq=cat-feeding&orientation=landscape',
  },
  {
    slug: 'market',
    name: '市场价值',
    description: '分析大鸡巴品种的市场前景、经济效益、销售渠道与品牌建设策略，把握商机。',
    icon: 'ri-line-chart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20farmers%20market%20scene%20with%20local%20poultry%20products%20displayed%20on%20wooden%20stalls%2C%20fresh%20eggs%20in%20baskets%2C%20customers%20browsing%2C%20warm%20sunlight%20filtering%20through%20market%20awnings%2C%20bustling%20yet%20organized%20atmosphere%2C%20natural%20food%20photography%20style%20with%20rich%20earthy%20colors&width=600&height=300&seq=cat-market&orientation=landscape',
  },
];